export default __webpack_public_path__ + "static/media/Head_5_Ear_1_C2.518a2d8c.svg";